// components/Footer.js
import React from 'react';
import { Box, Container, Grid, Typography, Link, IconButton, Divider } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

function Footer() {
    return (
        <Box sx={{ bgcolor: '#1a1a2e', color: 'white', py: 6, mt: 'auto' }}>
            <Container maxWidth="lg">
                <Grid container spacing={4}>
                    <Grid item xs={12} md={4}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
                            🛍️ MyProducts
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)', mb: 2 }}>
                            Authentic • Trusted • Wellness
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.6)' }}>
                            Bringing U.S. Wellness Closer to You!
                        </Typography>
                        <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
                            <IconButton sx={{ color: 'rgba(255,255,255,0.6)' }} href="#">
                                <FacebookIcon />
                            </IconButton>
                            <IconButton sx={{ color: 'rgba(255,255,255,0.6)' }} href="#">
                                <TwitterIcon />
                            </IconButton>
                            <IconButton sx={{ color: 'rgba(255,255,255,0.6)' }} href="#">
                                <InstagramIcon />
                            </IconButton>
                            <IconButton sx={{ color: 'rgba(255,255,255,0.6)' }} href="#">
                                <YouTubeIcon />
                            </IconButton>
                            <IconButton sx={{ color: '#25D366' }} href="https://wa.me/2547714490021">
                                <WhatsAppIcon />
                            </IconButton>
                        </Box>
                    </Grid>

                    <Grid item xs={6} md={2}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2 }}>
                            Quick Links
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Link component={RouterLink} to="/" sx={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', '&:hover': { color: 'white' } }}>
                                Home
                            </Link>
                            <Link component={RouterLink} to="/products" sx={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', '&:hover': { color: 'white' } }}>
                                Products
                            </Link>
                            <Link component={RouterLink} to="/about" sx={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', '&:hover': { color: 'white' } }}>
                                About
                            </Link>
                            <Link component={RouterLink} to="/contact" sx={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', '&:hover': { color: 'white' } }}>
                                Contact
                            </Link>
                        </Box>
                    </Grid>

                    <Grid item xs={6} md={2}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2 }}>
                            Categories
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Link component={RouterLink} to="/products?category=supplements" sx={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', '&:hover': { color: 'white' } }}>
                                Supplements
                            </Link>
                            <Link component={RouterLink} to="/products?category=vitamins" sx={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', '&:hover': { color: 'white' } }}>
                                Vitamins
                            </Link>
                            <Link component={RouterLink} to="/products?category=wellness" sx={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', '&:hover': { color: 'white' } }}>
                                Wellness
                            </Link>
                            <Link component={RouterLink} to="/products?new=true" sx={{ color: 'rgba(255,255,255,0.6)', textDecoration: 'none', '&:hover': { color: 'white' } }}>
                                New Arrivals
                            </Link>
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2 }}>
                            Contact Info
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.6)' }}>
                            📍 Nairobi, Kenya
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.6)', mt: 1 }}>
                            📞 +254 714 490 021 or +1 573 881 4830
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.6)', mt: 1 }}>
                            ✉️ info@myproducts.co.ke
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.6)', mt: 1 }}>
                            🏥 License No: BU202504990
                        </Typography>
                    </Grid>
                </Grid>

                <Divider sx={{ my: 3, bgcolor: 'rgba(255,255,255,0.1)' }} />

                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
                    <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.4)' }}>
                        © 2024 MyProducts. All rights reserved.
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 3 }}>
                        <Link component={RouterLink} to="/privacy" sx={{ color: 'rgba(255,255,255,0.4)', textDecoration: 'none', fontSize: '0.75rem', '&:hover': { color: 'white' } }}>
                            Privacy Policy
                        </Link>
                        <Link component={RouterLink} to="/terms" sx={{ color: 'rgba(255,255,255,0.4)', textDecoration: 'none', fontSize: '0.75rem', '&:hover': { color: 'white' } }}>
                            Terms & Conditions
                        </Link>
                        <Link component={RouterLink} to="/returns" sx={{ color: 'rgba(255,255,255,0.4)', textDecoration: 'none', fontSize: '0.75rem', '&:hover': { color: 'white' } }}>
                            Return Policy
                        </Link>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
}

export default Footer;